module.exports = __webpack_public_path__ + "img/slide-36.ad33052f.jpeg";